import { useState } from 'react';
import moment from 'moment';
import { TALENT_ARR } from '../../data/define';
import ToolTip from '../common/ToolTip';
import { useTranslation } from '../../hook/useTranslation';

function ChangAccumulatedSummary({ compareResult }) {
  const { t } = useTranslation();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <div className="w-full relative pt-[20px] pb-[20px]">
      <div className="flex items-center justify-between gap-2 mb-[20px]">
        <div className="flex items-center gap-2">
          <div className="text-[#1C1C1C] font-[700] text-[20px] text-left]">{t('report.change_summary.title')}</div>
          <ToolTip
            open={tooltipOpen}
            setOpen={setTooltipOpen}
            text={t('report.change_summary.tooltip')}
          />
        </div>
      </div>
      <div className="w-full grid grid-cols-3 gap-4">
        {compareResult?.topPerReport?.map((item, index) => {
          const targetIntelli = TALENT_ARR.find((talent) => talent.id === item.intelligence);
          return (
            <div key={`${item.intelligence}-${index}`} className="">
              <div className="flex flex-col justify-between items-center p-4 border border-[#EAEAEA] rounded-[12px] h-[164px]">
                <div className="w-[64px] flex flex-col justify-center items-center h-[64px] min-w-[64px] shrink-0 border border-[#EAEAEA] rounded-[20px]">
                  <img src={targetIntelli?.icon} alt={targetIntelli ? t(`talent.${targetIntelli.key}`) : ''} className="w-[38px]" />
                </div>
                <div className="text-[#363636] font-[700] text-[14px]">
                  {targetIntelli ? t(`talent.${targetIntelli.key}`) : ''}
                </div>
                <div className="text-[14px] font-[400] text-[#363636]">{t('report.summary.score', { score: item?.score })}</div>
              </div>
              <div className="text-[12px] font-[400] text-[#969696]">
                {moment(item?.updatedAt).format('MM.DD')}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ChangAccumulatedSummary;
